import {
  useListActiveRoomsByAccomodationIdQuery,
  useListRoomsByAccomodationIdQuery,
} from "../store/accomodation/accomodation";
import { Room } from "../types/accomodation.types";

interface UseRoomsQueryResult {
  rooms: Room[];
}

export const useRoomsQuery = (
  congressId: number,
  isEditMode: boolean,
  hotelId: number | string | undefined
): UseRoomsQueryResult => {
  const shouldFetchRooms =
    !!congressId && !!hotelId && !isNaN(parseInt(hotelId + ""));

  const roomsPublicQuery = useListActiveRoomsByAccomodationIdQuery(
    {
      congressId: congressId,
      accomodationId: hotelId as number,
    },
    {
      skip: isEditMode || !shouldFetchRooms,
    }
  );
  const roomsHiddenQuery = useListRoomsByAccomodationIdQuery(
    {
      congressId: congressId,
      accomodationId: hotelId as number,
    },
    {
      skip: !isEditMode || !shouldFetchRooms,
    }
  );

  const rooms = isEditMode
    ? roomsHiddenQuery.data ?? []
    : roomsPublicQuery.data ?? [];

  return {
    rooms,
  };
};
